"use client";

import { useTraceComponentRender } from "@faire/web/common/tracing/useTraceComponentRender";
import { useMergedRefs } from "@faire/web/ui/hooks/useMergedRefs";
import React, { forwardRef } from "react";

import {
  SDUIOnViewHandler,
  SDUIOnViewHandlerProps,
} from "@faire/retailer/components/SDUI/__internal__/SDUIOnViewHandler/SDUIOnViewHandler";
import { ComponentLoggingEventParams } from "@faire/retailer/components/SDUI/__internal__/types";
import { SDUIUPLTContext } from "@faire/retailer/components/SDUI/UPLT/SDUIUPLTContext";

type SDUIComponentClientCodeHandlerProps = {
  loggingData: ComponentLoggingEventParams;
  isRequiredForInteractivity?: boolean;
} & Omit<SDUIOnViewHandlerProps, "loggingData">;

export const SDUIComponentClientCodeHandler = forwardRef<
  HTMLDivElement,
  SDUIComponentClientCodeHandlerProps
>(({ isRequiredForInteractivity, ...rest }, ref) => {
  const UPLTRefCallback = React.useContext(SDUIUPLTContext)?.refCallback;

  const spanName = rest.loggingData.component_name;

  useTraceComponentRender(
    spanName ? "SDUIComponent: " + spanName : "SDUIComponentClientCodeHandler"
  );

  const mergedRefs = useMergedRefs(
    ref,
    isRequiredForInteractivity ? UPLTRefCallback : undefined
  );
  return <SDUIOnViewHandler {...rest} ref={mergedRefs} />;
});
